<template>

  <Header
    label="Tickets für"
    :headline="event.name"
  />

  <section class="bg-white py-20">
    <div class="container lg:flex lg:space-x-20">
      <div class="flex-none lg:w-1/3 mb-8">
        <div class="inline-block bg-white p-1 rounded-md shadow-md max-w-sm w-full">
        <img
            v-if="image"
            class="lazy block rounded bg-gray-100 w-full h-auto"
            :data-src="image.url"
            :height="image.height"
            :width="image.width"
            :alt="event.name"
          >
          <div v-else class="w-screen pb-[100%] rounded bg-gray-100 max-w-full"></div>
        </div>
      </div>

      <div class="flex-1 max-w-2xl">
        <h1 class="text-2xl text-blue-500 font-bold mb-4 mt-4">{{ event.name }}</h1>
        <p v-if="event.description" class="text-lg">{{ event.description }}</p>
      </div>
    </div>
  </section>

  <section class="bg-white pb-20">
    <div class="container">
      <h3 class="text-lg font-semibold mb-1 text-blue-500">Aufführungstermin</h3>
      <p class="text-gray-700">Wählen Sie Ihren Wunschtermin</p>
      <Select
        class="mt-4 w-96 max-w-full"
        v-model="state.date"
        @change="onChange"
      >
        <option
          v-for="event in event.options"
          :value="event.id"
        >
          {{ formatDate(event.date, 'dd. DD.MM.YYYY, HH:mm [Uhr]') }}
          ( {{ event.tickets_available }} / {{ event.tickets_count }} )
        </option>
      </Select>
    </div>
    <div class="container mt-12 relative">
      <div id="sitzplan" class="absolute -mt-5"></div>
      <h1 class="text-lg font-semibold mb-1 text-blue-500">Wählen Sie Ihren Sitzplatz</h1>
      <p class="text-gray-700">Bitte beachten Sie, dass das System für eine optimierte Belegung <strong>keine freien Plätze</strong> zwischen Gruppen zulässt.</p>
        <Seatplan
          v-bind="seatplan"
          class="relative rounded-lg mt-4 overflow-hidden"
          ref="element"
        />
    </div>
  </section>

  <section v-if="cart?.lines.length" class="bg-gray-300 py-20">
    <div class="container">
      <CartWithButtons :cart="cart" />
    </div>
  </section>

</template>

<script>
import Layout from 'Web/Layouts/WithCart.vue';

export default {
  layout: Layout,
}
</script>

<script setup>
import Seatplan from '@/components/Seatplan/Seatplan.vue';
import Select from 'Web/Form/Fields/SelectField.vue';
import Link from 'Web/Shared/Link.vue';
import Header from 'Web/Shared/Header.vue';
import useMeta from '@/compose/meta';
import useCart from '@/compose/cart';
import { computed, reactive, ref } from 'vue';
import formatDate from '@/helpers/formatDate';
import { Inertia } from '@inertiajs/inertia';
import CartWithButtons from 'Web/Cart/CartWithButtons.vue';

const props = defineProps({
  parent: {
    type: Object,
    required: true,
  },
  event: {
    type: Object,
    required: true,
  },
  date: {
    type: String,
    default: null,
  },
  seatplan: {
    type: Object,
    required: true,
  },
  cart: {
    type: Object,
    required: false,
  }
});

const { assign } = useMeta();
const { on } = useCart();

const element = ref(null);

on('expired', () => {
  Inertia.reload();
  element.value?.setup();
});

assign({
  title: `DAS DA-Onlineshop - ${props.event.name}`,
});

const image = computed(() => {
  return props.event.poster
    ?? props.parent.poster
    ?? props.event.cover
    ?? props.parent.cover
});

const state = reactive({
  date: props.date,
});

function onChange() {
  Inertia.reload({
    replace: true,
    data: { date: state.date },
  });
}

</script>
